module.exports = __webpack_public_path__ + "static/media/design1.d4b76c51.jpg";